import { createSlice } from "@reduxjs/toolkit";
import {
  addCustomerAPI,
  addOrganizationAPI,
  deleteOrganizationAPI,
  editCustomerAPI,
  editOrganizationAPI,
  getCustomerAPI,
  getCustomerTeamAPI,
  getOrganizationsAPI,
} from "../helpers/customerAPI";

const initialState = {
  customerData: [],
  devices: [],
  billingData: [],
  customerTickets: [
    {
      ticketId: "258956",
      subject: "Payment Failed",
      lastUpdated: "29 Jan 2023",
      status: "Resolved",
    },
  ],
  organizations: [],
  activeCustomerOrg: {},
  customerTeam: [],
};

export const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    setActiveCustomerOrg: (state, action) => {
      state.activeCustomerOrg = action?.payload;
    },
    resetStateCustomer: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(addCustomerAPI.fulfilled, (state, action) => {
        console.log("addCustomerAPI", action);
      })
      .addCase(addCustomerAPI.rejected, (state, action) => {
        console.log("addCustomerAPI", action);
      })
      .addCase(editCustomerAPI.fulfilled, (state, action) => {
        console.log("editCustomerAPI", action);
      })
      .addCase(editCustomerAPI.rejected, (state, action) => {
        console.log("editCustomerAPI", action);
      })
      .addCase(getCustomerAPI.fulfilled, (state, action) => {
        console.log("getCustomerAPI", action);
        state.customerData = action?.payload?.data;
      })
      .addCase(getCustomerAPI.rejected, (state, action) => {
        console.log("getCustomerAPI", action);
        state.customerData = [];
      })
      .addCase(addOrganizationAPI.fulfilled, (state, action) => {
        console.log("addOrganizationAPI", action);
      })
      .addCase(addOrganizationAPI.rejected, (state, action) => {
        console.log("addOrganizationAPI", action);
      })
      .addCase(getOrganizationsAPI.fulfilled, (state, action) => {
        state.organizations = action?.payload?.data;
      })
      .addCase(getOrganizationsAPI.rejected, (state) => {
        state.organizations = [];
      })
      .addCase(getCustomerTeamAPI.fulfilled, (state, action) => {
        state.customerTeam = action.payload.data;
      })
      .addCase(editOrganizationAPI.fulfilled, (state, action) => {
        console.log("editOrganizationAPI", action);
      })
      .addCase(editOrganizationAPI.rejected, (state, action) => {
        console.log("editOrganizationAPI", action);
      })
      .addCase(deleteOrganizationAPI.fulfilled, (state, action) => {
        console.log("deleteOrganizationAPI", action);
        state.organizations = action?.payload?.data;
      })
      .addCase(deleteOrganizationAPI.rejected, (state, action) => {
        console.log("loading Organization failed", action);
      })
      .addCase(getCustomerTeamAPI.rejected, (state) => {
        state.customerTeam = [];
      });
  },
});

export const { setActiveCustomerOrg, resetStateCustomer } = customersSlice.actions;

export default customersSlice.reducer;
